import { createReducer } from "@reduxjs/toolkit";
import {
  isqSelectOption,
  isqUnselectOption,
  isqSubmit,
  isqReset,
} from "./actions";

const initialState = {};

const ImageSelectionQuestionReducer = createReducer(initialState, (builder) => {
  builder.addCase(isqSelectOption, (state, action) => {
    const { componentID, optionID, selectedHotspot } = action.payload;

    if (!state[componentID]) {
      state[componentID] = { disabled: [] };
    }

    state[componentID].disabled = [
      ...(state[componentID].disabled || {}),
      { [selectedHotspot]: optionID },
    ];
  });
  builder.addCase(isqUnselectOption, (state, action) => {
    const { componentID, hotspotId } = action.payload;

    if (!state[componentID]) {
      state[componentID] = { disabled: [] };
    }

    state[componentID].disabled = state[componentID].disabled.filter(
      (item) => !Object.prototype.hasOwnProperty.call(item, hotspotId)
    );
    state[componentID].correctness = state[componentID].correctness.filter(
      (item) => !Object.prototype.hasOwnProperty.call(item, hotspotId)
    );
    state[componentID].attempted = false;
  });
  builder.addCase(isqSubmit, (state, action) => {
    const componentID = action.payload.id;
    const currentComponentState = state[componentID];

    let attempts = 1;
    if (currentComponentState.attempts) {
      attempts = currentComponentState.attempts + 1;
    }

    return {
      ...state,
      [componentID]: {
        ...currentComponentState,
        attempted: true,
        attempts: attempts,
        correctness: action.payload.correctness,
      },
    };
  });

  builder.addCase(isqReset, (state, action) => {
    const componentID = action.payload;
    const currentComponentState = state[componentID];
    if (currentComponentState) {
      if (currentComponentState.correctness) {
        delete currentComponentState.correctness;
      }
      currentComponentState.attempted = false;
      currentComponentState.disabled = [];
    }
  });
});

export default ImageSelectionQuestionReducer;
